import BusinessProfileIcon from "@material-ui/icons/AccountBalance"
import PrivacyPolicyIcon from "@material-ui/icons/ImportContacts"
import InvoiceListIcon from "@material-ui/icons/Receipt"
import InventoryListIcon from "@material-ui/icons/ViewList"
import DashboardIcon from "@mui/icons-material/Dashboard"
import EmailIcon from "@mui/icons-material/Email"
import BuyerListIcon from "@mui/icons-material/Person"
import RequestQuoteIcon from "@mui/icons-material/RequestQuote"
import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material"
import { FunctionComponent } from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { Link } from "react-router-dom"
import { Locale } from "../App"
import AppIconBn from "../assets/icon_bn.png"
import AppIconEn from "../assets/icon_en.webp"
import Color from "../Color"
import Dimen from "../Dimen"

const DrawerList: FunctionComponent<{
  locale: string
  toggleDrawer: (open: boolean) => void
  subscriber: boolean
}> = ({ locale, toggleDrawer, subscriber }) => {
  const intl = useIntl()

  return (
    <Box
      sx={{ width: 300 }}
      role="presentation"
      onClick={() => toggleDrawer(false)}
      onKeyDown={() => toggleDrawer(false)}
    >
      {/* List header with App Icon */}
      <List>
        <Link
          to="/"
          style={{
            textDecoration: "none",
            color: Color.Black,
          }}
        >
          <div
            style={{
              pointerEvents: "none",
              marginTop: "-8px",
              background: `linear-gradient(to bottom right, white, ${Color.PrimaryLight85})`,
            }}
          >
            <ListItemButton key={"bookkeeper"} style={{ height: "100px" }}>
              <ListItemIcon>
                {locale === Locale.Bengali && (
                  <img src={AppIconBn} alt="Shot_1" height={60} />
                )}
                {locale === Locale.English && (
                  <img src={AppIconEn} alt="Shot_1" height={60} />
                )}
              </ListItemIcon>
            </ListItemButton>
            <ListItemText
              style={{
                marginLeft: Dimen.MarginDefault,
                paddingBottom: Dimen.PaddingDefault,
              }}
              disableTypography
              primary={
                <Typography
                  style={{
                    fontSize: "x-large",
                  }}
                >
                  <FormattedMessage id="bookkeeper" />
                </Typography>
              }
            />
          </div>
        </Link>

        {/* Record list: Credit-debit */}
        {subscriber && (
          <Link
            to="/record-list"
            style={{ textDecoration: "none", color: Color.Black }}
          >
            <ListItemButton key={"dashboard"}>
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText
                primary={intl.formatMessage({
                  id: "nav.credit.debit",
                })}
              />
            </ListItemButton>
          </Link>
        )}

        {/* Inventory List */}
        {subscriber && (
          <Link
            to="/inventory-list"
            style={{ textDecoration: "none", color: Color.Black }}
          >
            <ListItemButton key={"inventoryList"}>
              <ListItemIcon>
                <InventoryListIcon />
              </ListItemIcon>
              <ListItemText
                primary={intl.formatMessage({
                  id: "nav.inventory.list",
                })}
              />
            </ListItemButton>
          </Link>
        )}

        {/* Buyer List */}
        {subscriber && (
          <Link
            to="/buyer-list"
            style={{ textDecoration: "none", color: Color.Black }}
          >
            <ListItemButton key={"buyerList"}>
              <ListItemIcon>
                <BuyerListIcon />
              </ListItemIcon>
              <ListItemText
                primary={intl.formatMessage({
                  id: "nav.buyer.list",
                })}
              />
            </ListItemButton>
          </Link>
        )}

        {/* Invoice List */}
        {subscriber && (
          <Link
            to="/invoice-list"
            style={{ textDecoration: "none", color: Color.Black }}
          >
            <ListItemButton key={"invoiceList"}>
              <ListItemIcon>
                <InvoiceListIcon />
              </ListItemIcon>
              <ListItemText
                primary={intl.formatMessage({
                  id: "nav.invoice.list",
                })}
              />
            </ListItemButton>
          </Link>
        )}

        {/* Business profile */}
        <Link
          to="/business-profile"
          style={{ textDecoration: "none", color: Color.Black }}
        >
          <ListItemButton key={"businessProfile"}>
            <ListItemIcon>
              <BusinessProfileIcon />
            </ListItemIcon>
            <ListItemText
              primary={intl.formatMessage({
                id: "nav.business.profile",
              })}
            />
          </ListItemButton>
        </Link>

        {/* Subscription */}
        <Link
          to="/subscription"
          style={{ textDecoration: "none", color: Color.Black }}
        >
          <ListItemButton key={"subscription"}>
            <ListItemIcon>
              <RequestQuoteIcon />
            </ListItemIcon>
            <ListItemText
              primary={intl.formatMessage({
                id: "subscription",
              })}
            />
          </ListItemButton>
        </Link>

        {/* Privacy policy */}
        <Link
          to="/privacy-policy"
          style={{ textDecoration: "none", color: Color.Black }}
        >
          <ListItemButton key={"privacyPolicy"}>
            <ListItemIcon>
              <PrivacyPolicyIcon />
            </ListItemIcon>
            <ListItemText
              primary={intl.formatMessage({
                id: "privacy.policy",
              })}
            />
          </ListItemButton>
        </Link>

        {/* Contact us */}
        <ListItemButton
          key={"contactUs"}
          onClick={() => {
            window.location.assign(
              "mailto:android.developer@eyeslave.com?subject=Bookkeeper Enterprise Website"
            )
          }}
        >
          <ListItemIcon>
            <EmailIcon />
          </ListItemIcon>
          <ListItemText
            primary={intl.formatMessage({
              id: "nav.contact.us",
            })}
          />
        </ListItemButton>
      </List>
    </Box>
  )
}

export default DrawerList
